<div class="lb-page" [class.lb-page--branded]="!!branding" [ngStyle]="brandingStyle">
  <div class="lb-backdrop" aria-hidden="true"></div>

  <main class="lb-shell" [class.lb-shell--thankyou]="success" [class.lb-shell--link-issue]="!!bookingLinkIssue && !success">
    <!-- Expired / invalid link or missing token: centered branded layout -->
    <div *ngIf="bookingLinkIssue && !success" class="lb-link-issue">
      <div class="lb-link-issue-brand">
        <div
          class="lb-brand-mark lb-brand-mark--hero"
          [class.lb-brand-mark--logo]="!!branding?.logo"
          [class.lb-brand-mark--fallback]="!branding?.logo"
          aria-hidden="true">
          <img *ngIf="branding?.logo" class="lb-brand-logo" [src]="branding.logo" alt="" />
        </div>
      </div>

      <section class="lb-card lb-link-issue-card">
        <div class="lb-link-issue-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="lb-link-issue-icon-svg">
            <path
              d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1.5 1.5M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 0 1-7-7l1.5-1.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round" />
            <path d="M4 4 20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </div>

        <ng-container *ngIf="bookingLinkIssue === 'expired'">
          <h1 class="lb-title lb-link-issue-title">This booking link has expired.</h1>
          <p class="lb-sub lb-link-issue-sub">Please contact your agent for a new booking link, if you still need an appointment.</p>
        </ng-container>
        <ng-container *ngIf="bookingLinkIssue === 'missing-token'">
          <h1 class="lb-title lb-link-issue-title">No booking link found</h1>
          <p class="lb-sub lb-link-issue-sub">
            Open this page using the full link from your SMS. If you copied the address, make sure nothing was cut off.
          </p>
        </ng-container>
      </section>
    </div>

    <header *ngIf="!bookingLinkIssue || success" class="lb-header">
      <div class="lb-brand lb-brand--header-row">
        <div class="lb-brand-copy">
          <ng-container *ngIf="success">
            <h1 class="lb-title">Thank you</h1>
            <p class="lb-sub">Your appointment is confirmed. We’re glad we could find a time that works.</p>
          </ng-container>
          <ng-container *ngIf="!success && !bookingLinkIssue">
            <h1 class="lb-title">Book a time</h1>
            <p class="lb-sub">Choose an available slot below. Times are shown in the agent’s calendar timezone.</p>
          </ng-container>
        </div>

        <div
          class="lb-brand-mark lb-brand-mark--header"
          [class.lb-brand-mark--logo]="!!branding?.logo"
          [class.lb-brand-mark--fallback]="!branding?.logo"
          aria-hidden="true">
          <img *ngIf="branding?.logo" class="lb-brand-logo" [src]="branding.logo" alt="" />
        </div>
      </div>
    </header>

    <ng-container *ngIf="!bookingLinkIssue && token">
      <section *ngIf="success" class="lb-card lb-card--success lb-thankyou" aria-live="polite">
        <div class="lb-thankyou-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" stroke="currentColor" stroke-width="1.6" />
            <path d="M8.25 12.25 11 15l4.75-5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <h2 class="lb-thankyou-title">You’re booked</h2>
        <p class="lb-card-text lb-thankyou-text">
          Your appointment has been confirmed. You should receive a calendar invite or confirmation from the office shortly.
        </p>
        <p *ngIf="bookedSlot" class="lb-thankyou-when">
          <span class="lb-thankyou-when-label">When</span>
          <span class="lb-thankyou-when-value">{{ formatBookedWhen(bookedSlot) }}</span>
          <span class="lb-thankyou-when-tz">{{ bookedSlot.timezone }}</span>
        </p>
      </section>

      <section class="lb-toolbar lb-card" *ngIf="!success">
        <div class="lb-toolbar-dates">
          <span class="lb-range">{{ rangeLabel }}</span>
          <span class="lb-hint">Showing 7 days</span>
        </div>
        <div class="lb-toolbar-actions">
          <button type="button" class="lb-btn lb-btn--ghost" (click)="prevWeek()" [disabled]="loading">Previous</button>
          <button type="button" class="lb-btn lb-btn--ghost" (click)="nextWeek()" [disabled]="loading">Next</button>
        </div>
      </section>

      <div *ngIf="apiMessage && !success" class="lb-banner" role="status">{{ apiMessage }}</div>

      <div *ngIf="loading && !success" class="lb-loading" aria-busy="true" aria-label="Loading availability">
        <span class="lb-spinner"></span>
        <span>Finding available times…</span>
      </div>

      <ng-container *ngIf="!loading && !success">
        <p *ngIf="!dayGroups.length && !apiMessage" class="lb-empty">No open slots in this week. Try another range.</p>

        <div class="lb-days" *ngIf="dayGroups.length">
          <section class="lb-day" *ngFor="let g of dayGroups; trackBy: trackByDay">
            <h2 class="lb-day-title">{{ g.label }}</h2>
            <ul class="lb-slot-list">
              <li *ngFor="let slot of g.slots; trackBy: trackBySlot">
                <button type="button" class="lb-slot" [class.lb-slot--active]="selected?.slot_start === slot.slot_start" (click)="selectSlot(slot)">
                  <span class="lb-slot-time">{{ formatSlotRange(slot) }}</span>
                  <!-- <span class="lb-slot-tz">{{ slot.timezone }}</span> -->
                </button>
              </li>
            </ul>
          </section>
        </div>
      </ng-container>

      <footer class="lb-sticky" *ngIf="selected && !success">
        <div class="lb-sticky-inner lb-card">
          <div class="lb-sticky-copy">
            <span class="lb-sticky-label">Selected</span>
            <span class="lb-sticky-value">{{ formatSlotRange(selected) }} · {{ selected.timezone }}</span>
          </div>
          <button type="button" class="lb-btn lb-btn--primary" (click)="confirmBooking()" [disabled]="booking">
            {{ booking ? 'Booking…' : 'Confirm booking' }}
          </button>
        </div>
      </footer>
    </ng-container>
  </main>
</div>
